"use client";

import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const testimonials = [{
    quote: "Endlich ein angenehmes Raumklima im Dachgeschoss, ohne dass man störende Geräte sieht oder hört. Die Installation war absolut professionell.",
    name: "Familie M.",
    childAge: "Einfamilienhaus, Stuttgart",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_family_m.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_family_m.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_family_m.png-wvc-sizes"
  }, {
    quote: "Die Lösung ist perfekt versteckt. Im Sommer kühlt es wunderbar und im Winter heizen wir effizient. Eine echte Aufwertung für unser Zuhause.",
    name: "Herr K.",
    childAge: "Reihenhaus, Karlsruhe",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_herr_k.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_herr_k.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_herr_k.png-wvc-sizes"
  }, {
    quote: "Wir haben lange nach einer Lösung gesucht, die nicht nur kühlt, sondern auch die gesetzlichen Anforderungen erfüllt. Ducted AC System war die beste Entscheidung.",
    name: "Frau S.",
    childAge: "Dachgeschosswohnung, Freiburg",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_frau_s.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_frau_s.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_frau_s.webp-wvc-sizes"
  }, {
    quote: "Flüsterleise und zugfrei. Man merkt gar nicht, dass die Anlage läuft – außer dass es plötzlich überall die perfekte Temperatur hat.",
    name: "Familie B.",
    childAge: "Einfamilienhaus, Heidelberg",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_familie_b.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_familie_b.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_familie_b.png-wvc-sizes"
  }, {
    quote: "Die Planung war exzellent. Die Integration in den Dachboden ist so diskret, dass man nur die angenehme Luftqualität bemerkt.",
    name: "Herr P.",
    childAge: "Altbau-Sanierung, Ulm",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_herr_p.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_herr_p.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_herr_p.webp-wvc-sizes"
  }, {
    quote: "Endlich schlafen wir auch bei Hitze gut. Die Anlage ist so leise, dass sie im Schlafzimmer absolut nicht stört. Sehr empfehlenswert!",
    name: "Familie H.",
    childAge: "Einfamilienhaus, Mannheim",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_familie_h.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_familie_h.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/testimonial_familie_h.png-wvc-sizes"
  }];
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="1078" id="stimmen-unserer-kunden" className="relative overflow-hidden bg-background text-foreground py-28 md:py-36">
      {}
      <svg className="absolute top-0 left-0 w-full text-background" viewBox="0 0 1440 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 C120,18 240,6 360,10 C480,14 600,4 720,8 C840,12 960,20 1080,14 C1200,8 1320,16 1440,10 L1440,0 Z" fill="currentColor" />
      </svg>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute top-1/3 right-[8%] h-[520px] w-[520px] rounded-lg bg-accent/35 blur-3xl" style={{
      borderRadius: "42% 58% 51% 49% / 47% 52% 48% 53%",
      mixBlendMode: "multiply"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -top-12 left-[10%] h-[380px] w-[380px] bg-secondary/40 blur-3xl" style={{
      borderRadius: "55% 45% 60% 40% / 50% 55% 45% 50%",
      mixBlendMode: "multiply"
    }} />

      <div ref={ref} className={`relative mx-auto max-w-[1320px] px-[clamp(1.25rem,4vw,3rem)] transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          {}
          <div className="relative lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="font-mono text-xs uppercase tracking-[0.18em] text-chart-2">
                 Kundenstimmen — Ducted AC System Erfahrungen
              </span>
            </div>

            <h2 className="font-default mt-6 font-serif text-[clamp(2rem,4.2vw,3.75rem)] font-normal leading-[1.05] tracking-tight text-foreground">
              Was unsere{" "}
              <span className="inline-block italic text-chart-2" style={{
              transform: "rotate(-1.5deg) translateY(2px)"
            }}>
                Kunden über uns sagen
              </span>
            </h2>

            <p className="mt-6 max-w-md font-sans text-[clamp(1.0625rem,1.15vw,1.1875rem)] leading-[1.65] text-foreground/80">
              Erfahren Sie, wie Hausbesitzer in ganz Baden-Württemberg mit unserem Ducted AC System ihr Wohnklima nachhaltig verbessert haben.
            </p>

            {}
            <div className="mt-10 flex items-center gap-5">
              <Button variant="outline" size="icon" onClick={() => api?.scrollPrev()} aria-label="Previous testimonial" className="size-12 rounded-lg border-[1.5px] bg-transparent shadow-sm transition-all hover:scale-[1.02] border-chart-2 text-chart-2">
                <ChevronLeft className="size-5" />
              </Button>

              <div className="flex items-center gap-2">
                <span className="font-mono text-sm font-medium tabular-nums text-chart-2">
                  {String(current + 1).padStart(2, "0")}
                </span>
                {}
                <div className="flex items-center gap-1.5 px-2">
                  {Array.from({
                  length: count
                }).map((_, i) => <span key={i} data-index={i} className="transition-all duration-300" aria-hidden="true">
                      <svg width="10" height="12" viewBox="0 0 10 12" fill="none" className={i === current ? "opacity-100" : "opacity-30"}>
                        <ellipse cx="5" cy="7.5" rx="3.5" ry="4" fill={i === current ? "var(--primary)" : "var(--foreground)"} />
                        <path d="M2.5 4 Q5 1.5 7.5 4" stroke="var(--foreground)" strokeWidth="1" fill="none" strokeLinecap="round" />
                        <path d="M5 1 L5 3" stroke="var(--foreground)" strokeWidth="1" strokeLinecap="round" />
                      </svg>
                    </span>)}
                </div>
                <span className="font-mono text-sm text-foreground/50 tabular-nums">
                  {String(count).padStart(2, "0")}
                </span>
              </div>

              <Button variant="outline" size="icon" onClick={() => api?.scrollNext()} aria-label="Next testimonial" className="size-12 rounded-lg border-[1.5px] bg-transparent shadow-sm transition-all hover:scale-[1.02] border-chart-2 text-chart-2">
                <ChevronRight className="size-5" />
              </Button>
            </div>

            {}
            <div className="pointer-events-none mt-12 hidden lg:block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/naber_airconduct_installation_view.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/naber_airconduct_installation_view.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/naber_airconduct_installation_view.png-wvc-sizes" alt="" loading="lazy" decoding="async" className="h-[180px] w-auto opacity-95" />
            </div>
          </div>

          {}
          <div className="relative lg:col-span-7">
            <Carousel setApi={setApi} opts={{
            loop: true,
            align: "start"
          }} className="w-full">
              <CarouselContent>
                {testimonials.map((t, i) => <CarouselItem key={i} data-index={i}>
                    <div className="relative">
                      {}
                      <svg aria-hidden="true" className="absolute -top-2 -right-2 z-10 h-12 w-12" viewBox="0 0 48 48" fill="none">
                        <path d="M48 0 L48 28 Q40 32 32 36 Q24 40 20 48 L48 48 Z" fill="var(--accent)" opacity="0.45" />
                        <path d="M48 0 L48 28 Q40 32 32 36 Q24 40 20 48" stroke="var(--chart-2)" strokeWidth="1" fill="none" opacity="0.5" />
                      </svg>

                      <div className="relative rounded-2xl bg-background p-8 shadow-md md:p-10">
                        {}
                        <div className="absolute -top-2 left-6 font-serif italic leading-none text-accent" style={{
                      fontSize: "4rem"
                    }} aria-hidden="true">
                          <Quote className="size-14 -scale-x-100" strokeWidth={1.5} fill="var(--accent)" />
                        </div>

                        {}
                        <div className="mt-6 flex items-center gap-1.5">
                          {Array.from({
                        length: 5
                      }).map((_, s) => <Star key={s} data-index={s} className="size-5 fill-primary text-primary" strokeWidth={1.5} />)}
                        </div>

                        {}
                        <p className="font-default mt-6 font-serif text-[clamp(1.25rem,1.6vw,1.5rem)] font-normal leading-[1.4] text-foreground">
                          {t.quote}
                        </p>

                        {}
                        <div className="mt-8 flex items-center gap-4 border-t border-border pt-6">
                          <div className="relative h-14 w-14 shrink-0 overflow-hidden rounded-lg shadow-sm" style={{
                        borderRadius: "52% 48% 58% 42% / 50% 55% 45% 50%"
                      }}>
                            <img src={t.avatar} data-wvc-srcset={t.srcset} data-wvc-sizes={t.sizes} alt={t.name} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                          </div>
                          <div className="flex flex-col">
                            <span className="font-default font-sans text-base font-bold text-foreground">
                              {t.name}
                            </span>
                            <span className="font-sans text-sm text-foreground/70">
                              {t.childAge}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
            </Carousel>
          </div>
        </div>
      </div>

      {}
      <svg className="absolute bottom-0 left-0 w-full rotate-180 text-background" viewBox="0 0 1440 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 C120,18 240,6 360,10 C480,14 600,4 720,8 C840,12 960,20 1080,14 C1200,8 1320,16 1440,10 L1440,0 Z" fill="currentColor" />
      </svg>
    </section>;
}